export default [
  {
    path: '/maintenance',
    name: 'maintenance',
    meta: { 
      layout: "default",
      public: true,
      breadcrumb: [{ label: 'Maintenance' }]
    },
    component: () => import('../pages/Maintenance.vue'),
    
  },
  {
    path: '/error',
    name: 'error',
    meta: { public: true },
    component: () => import('../pages/NotFound.vue')
  }
]
